import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import ForwardCallForm from './ForwardCallForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    record: false,
    timeout: 30,
    ...otherProps.initialValues,
    number: Array.isArray(otherProps.initialValues.number)
      ? otherProps.initialValues.number
      : [otherProps.initialValues.number],
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(ForwardCallForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ForwardCall/ForwardCallForm.container.js